import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import i18n from "i18next";

import { useActiveLanguages } from "../store/languages/language.selectors";

import { getHtmlDirection } from "../utils/helpers";
import { isSSR } from "../utils/helpers/isSSR";

import { useContent } from "./use-content";
import { useMatchRoute } from "./use-match-route";

const useMetaDate = () => {
  const [currentSeo, setCurrentSeo] = useState({});

  const { lang, filter } = useParams();
  const { store, isDataLoaded, countryInfo } = useContent();
  const { languages } = useActiveLanguages();

  const tag = useMatchRoute()?.tag;

  const language = lang || i18n.language;
  const pageTag = filter || tag || "home";

  const htmlDir = getHtmlDirection(languages, language);

  useEffect(() => {
    const contentMeta = store?.[pageTag]?.[language]?.metaData;

    if (
      isDataLoaded &&
      contentMeta &&
      Object.entries(contentMeta).length !== 0
    ) {
      setCurrentSeo(prevState => ({
        ...prevState,
        ...contentMeta,
        countryInfo: countryInfo?.data,
      }));
    }
  }, [store, language, pageTag, countryInfo.data]);

  if (isSSR()) {
    if (store?.[pageTag]?.[language]?.metaData) {
      return {
        ...store?.[pageTag]?.[language]?.metaData,
        language,
        countryInfo: countryInfo?.data,
      };
    }
  }

  return { ...currentSeo, language, htmlDir };
};

export default useMetaDate;
